export const BREAKPOINTS = {
    laptop: 1366, // Windows laptop, minimum supported
    macbookAir: 1440, // MacBook / older MacBook Air, macOS scaled
    windowsScaled: 1536, // Windows laptop with scaling, very common
    desktopHDPlus: 1600, // Windows laptop / desktop
    desktop16x10: 1680, // MacBook / desktop, 16:10
    desktopFullHD: 1920, // Windows laptop / desktop, Full HD
    desktopFullHD16x10: 1920, // Windows or Mac-style 16:10 laptop
    desktopScaled: 2048, // High-resolution Windows/macOS scaled viewport
    surfaceLaptop: 2256, // Surface-style Windows laptop, 3:2 ratio
    macbookRetina: 2304, // MacBook Retina-style resolution
    desktopQHD: 2560, // Windows desktop / QHD monitor
    macbookProRetina: 2880, // MacBook Pro Retina-style resolution
    macbookProScaled: 3008, // MacBook Pro scaled viewport
    windowsHighEnd: 3200, // High-end Windows laptop
    ultrawide: 3440, // Optional ultrawide desktop
    desktop4K: 3840, // 4K Windows/macOS desktop or laptop
} as const;

const getMedia = <T extends number>(breakpoint: T): `(min-width: ${T}px)` => `(min-width: ${breakpoint}px)`;

export const media = {
    laptop: getMedia(BREAKPOINTS.laptop),
    macbookAir: getMedia(BREAKPOINTS.macbookAir),
    windowsScaled: getMedia(BREAKPOINTS.windowsScaled),
    desktopHDPlus: getMedia(BREAKPOINTS.desktopHDPlus),
    desktop16x10: getMedia(BREAKPOINTS.desktop16x10),
    desktopFullHD: getMedia(BREAKPOINTS.desktopFullHD),
    aboveDesktopFullHD: getMedia(BREAKPOINTS.desktopFullHD + 1),
    desktopFullHD16x10: getMedia(BREAKPOINTS.desktopFullHD16x10),
    desktopScaled: getMedia(BREAKPOINTS.desktopScaled),
    surfaceLaptop: getMedia(BREAKPOINTS.surfaceLaptop),
    macbookRetina: getMedia(BREAKPOINTS.macbookRetina),
    desktopQHD: getMedia(BREAKPOINTS.desktopQHD),
    macbookProRetina: getMedia(BREAKPOINTS.macbookProRetina),
    macbookProScaled: getMedia(BREAKPOINTS.macbookProScaled),
    windowsHighEnd: getMedia(BREAKPOINTS.windowsHighEnd),
    ultrawide: getMedia(BREAKPOINTS.ultrawide),
    desktop4K: getMedia(BREAKPOINTS.desktop4K),
} as const;

export const CUSTOM_LAYOUT_WRAPPER_ID = 'custom-main-layout-wrapper';

// content width for user pages on screens wider than 1920px.
// keeps the Learning carousel wide enough for 3 cards without causing horizontal scroll.
export const ABOVE_DESKTOP_FULL_HD_CONTENT_WIDTH = 1478;
